export const ITEMS_PER_PAGE = 10

export const QUERY_PARAMS = {
  PAGE: 'page',
  SEARCH_ID: 'search_id',
  SEARCH_CUSTOMER: 'search_customer',
  SEARCH_ADDRESS: 'search_address',
  STATUS: 'status',
  SORT: 'sort',
  DATE_FROM: 'date_from',
  DATE_TO: 'date_to',
  DEADLINE_FROM: 'deadline_from',
  DEADLINE_TO: 'deadline_to',
} as const

// Used when client-side filters are active: fetch a large batch so JS predicates can run over it.
// The API has no equivalent for text searches or multi-status OR logic.
export const ALL_INVOICES_PER_PAGE = 500

export const INVOICE_STATUS = {
  DRAFT: 'draft',
  FINALIZED: 'finalized',
  PAID: 'paid',
  UNPAID: 'unpaid',
} as const

export type InvoiceStatus = (typeof INVOICE_STATUS)[keyof typeof INVOICE_STATUS]

export const STATUS_OPTIONS = [
  { label: 'Draft', value: INVOICE_STATUS.DRAFT },
  { label: 'Finalized', value: INVOICE_STATUS.FINALIZED },
  { label: 'Paid', value: INVOICE_STATUS.PAID },
  { label: 'Unpaid', value: INVOICE_STATUS.UNPAID },
]

export const SORT_PREFIX = {
  ASC: '+',
  DESC: '-',
} as const

export const INVOICE_STATUS_COLORS = {
  FINALIZED: 'blue',
  DRAFT: 'orange',
  PAID: 'green',
  UNPAID: 'orange',
} as const
